module.exports = __webpack_public_path__ + "static/media/icomoon.9b29c139.eot";